// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3mCEs","title":"Info_title__270cV","selects":"Info_selects__ww1HQ","requiredAsterisk":"Info_requiredAsterisk__2Ju_L"};